import DynamicFieldsHandler from "~/models/dynamicFields/handlers/dynamicFieldsHandler";
import {IHandlerConfig} from "~/interfaces/dynamicFieldsElementOptionsInterfaces";

export default class HandlerOfHandlers extends DynamicFieldsHandler {

  constructor(public handlerConfig: Array<IHandlerConfig> ) {
    super();
  }

  get SECTIONS() {
    const sections = [];
    this.handlers.forEach(x => sections.push(...x.SECTIONS));
    return sections;
  }
  set SECTIONS(val: Array<string>) {
    // Do nothing
  }

  get handlers(): Array<DynamicFieldsHandler> {
    return Object.values(this.handlerConfig).map(h => h.handler);
  }

  getAll(area?: string): DynamicFieldsHandler[] {
    // Get out handlers by section
    const handlers = [];
    this.handlers.forEach(h => handlers.push(...h.getAll(area)));
    return handlers;
  }
}